import {CheckTypeDisplay, MonitoringServiceType} from "@/lib/types/checks.ts";

interface CheckDeleteDialogBodyProps {
  name: string;
  serviceType: MonitoringServiceType;
}

export const CheckDeleteDialogBody = ({name, serviceType}: CheckDeleteDialogBodyProps) => (
  <>
    <p>
      Are you sure you want to delete the <code>{CheckTypeDisplay[serviceType]}</code> Check <code>{name}</code>?
    </p>
    <p>This Check and its associated Alerts will be permanently deleted and non-recoverable after 30 days.</p>
    <p>
      <strong>Note:</strong> Deleting a group Check will neither delete its nested Checks nor any Alerts associated with
      those.
    </p>
  </>
);
